class NewsletterForm extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    const inputField = this.querySelector('input.email-input');
    inputField.addEventListener('focus', (ev) => {
      this.querySelector('.consent-message').classList.add('open');
    });
    inputField.addEventListener('blur', (ev) => {
      this.querySelector('.consent-message').classList.remove('open');
    });
  }
}

customElements.define('newsletter-form', NewsletterForm);
